import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Trash2, Plus } from "lucide-react";
import { toast } from "sonner";

export default function AdminDiscounts() {
  const [list, setList] = useState([]);
  const [code, setCode] = useState("");
  const [percent, setPercent] = useState(10);

  const load = () => api.get("/admin/discounts").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/discounts", { code: code.toUpperCase(), percent_off: parseFloat(percent), active: true });
      setCode(""); setPercent(10);
      toast.success("Discount created");
      load();
    } catch {
      toast.error("Could not create");
    }
  };

  const remove = async (c) => {
    await api.delete(`/admin/discounts/${c}`);
    load();
  };

  return (
    <div data-testid="admin-discounts-page">
      <div className="pg-micro mb-2">// Discount Codes</div>
      <h1 className="text-[#F7FAFC] text-3xl pg-display mb-8" style={{ fontFamily: "'Exo 2'" }}>Promotions</h1>

      <form onSubmit={create} className="pg-card p-5 mb-6 grid grid-cols-1 sm:grid-cols-3 gap-3 items-end">
        <label className="block">
          <div className="pg-micro mb-2">Code</div>
          <input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} className="pg-input" required data-testid="new-discount-code" />
        </label>
        <label className="block">
          <div className="pg-micro mb-2">% Off</div>
          <input type="number" min="0" max="100" value={percent} onChange={(e) => setPercent(e.target.value)} className="pg-input" required data-testid="new-discount-percent" />
        </label>
        <button type="submit" className="pg-btn-primary" data-testid="create-discount">
          <Plus size={14} /> Create
        </button>
      </form>

      <div className="space-y-2">
        {list.map((d) => (
          <div key={d.id} className="pg-card p-4 flex items-center justify-between">
            <div>
              <div className="text-[#A6FF00] pg-display text-xl" style={{ fontFamily: "'Exo 2'" }}>{d.code}</div>
              <div className="text-[#9CA8B8] text-sm" data-testid={`discount-terms-${d.code}`}>
                {d.amount_off ? `£${Number(d.amount_off).toFixed(2)} off` : `${d.percent_off}% off`}
                {d.min_spend ? ` · min spend £${Number(d.min_spend).toFixed(2)}` : ""}
                {d.free_shipping ? " · free delivery" : ""}
                {d.max_uses ? ` · ${d.times_used || 0}/${d.max_uses} used` : d.times_used ? ` · used ${d.times_used}×` : ""}
                {d.expires_at ? ` · expires ${new Date(d.expires_at).toLocaleDateString("en-GB", { day: "numeric", month: "short" })}` : ""}
              </div>
            </div>
            <button onClick={() => remove(d.code)} className="text-[#9CA8B8] hover:text-red-400" data-testid={`delete-${d.code}`}>
              <Trash2 size={16} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
